/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DirectSaleRequest,
  DirectSaleResponse,
  ErrorMessage,
  PayOpenTableRequest,
  PayOpenTableResponse,
  RefundPaymentRequest,
  RefundPaymentResponse,
} from '../models';
import {
    DirectSaleRequestFromJSON,
    DirectSaleRequestToJSON,
    DirectSaleResponseFromJSON,
    DirectSaleResponseToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    PayOpenTableRequestFromJSON,
    PayOpenTableRequestToJSON,
    PayOpenTableResponseFromJSON,
    PayOpenTableResponseToJSON,
    RefundPaymentRequestFromJSON,
    RefundPaymentRequestToJSON,
    RefundPaymentResponseFromJSON,
    RefundPaymentResponseToJSON,
} from '../models';

export interface DirectSalePaymentRequest {
    directSaleRequest: DirectSaleRequest;
}

export interface InitiateOpenTablePaymentRequest {
    payOpenTableRequest: PayOpenTableRequest;
}

export interface InitiateRefundRequest {
    refundPaymentRequest: RefundPaymentRequest;
}

/**
 * 
 */
export class F1ControllerApi extends runtime.BaseAPI {

    /**
     */
    async directSalePaymentRaw(requestParameters: DirectSalePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DirectSaleResponse>> {
        if (requestParameters.directSaleRequest === null || requestParameters.directSaleRequest === undefined) {
            throw new runtime.RequiredError('directSaleRequest','Required parameter requestParameters.directSaleRequest was null or undefined when calling directSalePayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/direct-sale-payments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DirectSaleRequestToJSON(requestParameters.directSaleRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DirectSaleResponseFromJSON(jsonValue));
    }

    /**
     */
    async directSalePayment(requestParameters: DirectSalePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DirectSaleResponse> {
        const response = await this.directSalePaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async initiateOpenTablePaymentRaw(requestParameters: InitiateOpenTablePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayOpenTableResponse>> {
        if (requestParameters.payOpenTableRequest === null || requestParameters.payOpenTableRequest === undefined) {
            throw new runtime.RequiredError('payOpenTableRequest','Required parameter requestParameters.payOpenTableRequest was null or undefined when calling initiateOpenTablePayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/initiate-open-table-payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PayOpenTableRequestToJSON(requestParameters.payOpenTableRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PayOpenTableResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateOpenTablePayment(requestParameters: InitiateOpenTablePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayOpenTableResponse> {
        const response = await this.initiateOpenTablePaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async initiateRefundRaw(requestParameters: InitiateRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefundPaymentResponse>> {
        if (requestParameters.refundPaymentRequest === null || requestParameters.refundPaymentRequest === undefined) {
            throw new runtime.RequiredError('refundPaymentRequest','Required parameter requestParameters.refundPaymentRequest was null or undefined when calling initiateRefund.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/initiate-refund`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefundPaymentRequestToJSON(requestParameters.refundPaymentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefundPaymentResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateRefund(requestParameters: InitiateRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefundPaymentResponse> {
        const response = await this.initiateRefundRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
